import { ChevronLeft, ChevronRight } from "lucide-react";

const button = "inline-flex items-center gap-1 min-h-[40px] px-3 py-2 rounded-full border border-slate-200 bg-white text-sm font-semibold text-slate-700 disabled:opacity-40 hover:border-teal-300";

export const OrganizerPagination = ({ page, pages, total, pageSize, onPage }) => {
  if (!total) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3" data-testid="organizer-pagination">
      <div className="text-xs text-slate-500" data-testid="organizer-range">Showing {start}–{end} of {total}</div>
      <div className="flex items-center gap-2">
        <button type="button" data-testid="organizer-prev-page" onClick={() => onPage(page - 1)} disabled={page <= 1} className={button}><ChevronLeft size={14} /> Prev</button>
        <span className="text-sm font-semibold text-slate-700" data-testid="organizer-page-label">Page {page} of {pages}</span>
        <button type="button" data-testid="organizer-next-page" onClick={() => onPage(page + 1)} disabled={page >= pages} className={button}>Next <ChevronRight size={14} /></button>
      </div>
    </div>
  );
};
